
// Normal imports
import { useState, useEffect } from 'react';

import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';

// Page imports
import Art from './art/Art.js';
import Charts from './charts/Charts.js';
import CV from './cv/CV.js';
import Glossary from './glossary/Glossary.js';
import RelatedLinks from './glossary/RelatedLinks.js';
import Home from './home/Home.js';
import Me from './myself/Myself.js';
import AppleInterface from './projects/large/AppleInterface.js';
import BerkoPick from './projects/large/BerkoPick.js';
import ChromeContextControl from './projects/large/ChromeContextControl.js';
import Dissertation from './projects/large/Dissertation.js';
import DissertationTool from './projects/large/DissertationTool.js';
import ShortStoreyInfo from './projects/large/ShortStoreyInfo.js';
import Snowstorm from './projects/large/Snowstorm.js';
import SpotifyRoulette from './projects/large/SpotifyRoulette.js';
import SquarePaint from './projects/large/SquarePaint.js';
import TrafficSimulator from './projects/large/TrafficSimulator.js';
import UnicodeChess from './projects/large/UnicodeChess.js';
import WalkAnywhere from './projects/large/WalkAnywhere.js';
import ZachLang from './projects/large/ZachLang.js';
import Projects from './projects/Projects.js';
import Disco from './random/Disco.js';
import { FruitLips, FruitLips2, FruitLips3, ShortStorey, SpotifyRouletteIframe, Squares, LLMCompare, BerkoLitterPick } from './submodules/submodules.js';
import { BackButton, BackButtonProvider } from './util/BackButtons.js';
import { BreadcrumbLink, BreadcrumbProvider, DropBreadcrumbs } from './util/Breadcrumbs.js';
import { useMask } from './util/Mask.js';
import NoiseBackground from './util/NoiseBackground.js';
import NotFound from './util/NotFound.js';
import WalkAnywhereApp from './walkanywhere-app/WalkAnywhereApp.js';

// main app
function App() {
  const { displayMask, MaskOverlay } = useMask();

  const noFooter = ['/', '/me', '/fruit-lips', '/apple-interface', '/berko-litter-pick', '/shortstorey', '/spotify-roulette-demo', '/walkanywhere-app'];
  const [galleryTableView, setGalleryTableView] = useState(false);

  const location = useLocation();
  const hideFooter = noFooter.includes(location.pathname) || (location.pathname === '/gallery' && galleryTableView);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.key]);

  const largeProjects = [
    {route: 'dissertation', page: Dissertation},
    {route: 'unicode-chess', page: UnicodeChess},
    {route: 'spotify-roulette', page: SpotifyRoulette},
    {route: 'snowstorm', page: Snowstorm},
    {route: 'chrome-context-control', page: ChromeContextControl},
    {route: 'traffic-simulator', page: TrafficSimulator},
    {route: 'square-paint', page: SquarePaint},
    {route: 'shortstorey-info', page: ShortStoreyInfo},
    {route: 'zach-lang', page: ZachLang},
    {route: 'berko-pick', page: BerkoPick},
    {route: 'walkanywhere', page: WalkAnywhere},
    {route: 'appleinterface', page: AppleInterface},
  ];

  function isIOS() {
    return /iP(hone|od|ad)/.test(navigator.userAgent);
  }

  return(
    <div id="all" className='app'>
      {MaskOverlay()}
      {location.pathname === '/me' && <NoiseBackground />}
      <BreadcrumbProvider>
        <BackButtonProvider>
          <BackButton />
          <div className='crumb-holder'>
            <DropBreadcrumbs />
          </div>
          <Routes>
            <Route exact path='/' element={<Home/>} />
            <Route path='/me' element={<Me/>} />
            <Route path='/cv' element={<CV/>} />
            <Route path='/projects' element={<Projects displayMask={displayMask}/>} />
            <Route path='/gallery' element={<Art displayMask={displayMask} onViewChange={setGalleryTableView}/>} />
            <Route path='/charts' element={<Charts/>} />
            <Route path='/dissertation-tool' element={<DissertationTool/>} />
            <Route path='/fruit-lips' element={<FruitLips/>} />
            <Route path='/fruit-lips2' element={<FruitLips2/>} />
            <Route path='/apple-interface' element={<FruitLips3/>} />
            <Route path='/368squares' element={<Squares/>} />
            <Route path='/llm-compare' element={<LLMCompare/>} />
            <Route path='/berko-litter-pick' element={<BerkoLitterPick/>} />
            <Route path='/glossary' element={<Glossary/>} />
            <Route path='/related-links' element={<RelatedLinks/>} />
            <Route path='/shortstorey' element={<ShortStorey/>} />
            <Route path='/spotify-roulette-demo' element={<SpotifyRouletteIframe/>} />
            <Route path='/disco' element={<Disco/>} />
            <Route path='/walkanywhere-app' element={<WalkAnywhereApp/>} />
            {largeProjects.map(project => 
              <Route key={project.route} path={`/${project.route}`} element={<project.page displayMask={displayMask} isIOS={isIOS} />} />
            )}
            <Route path='*' element={<NotFound/>} />
          </Routes>
          <div className={`footer ${hideFooter ? 'none' : ''}`}>
            <hr />
            <nav className='footer-nav'>
              <BreadcrumbLink to='/me'>About</BreadcrumbLink>
              <BreadcrumbLink to='/projects'>Projects</BreadcrumbLink>
              <BreadcrumbLink to='/gallery'>Gallery</BreadcrumbLink>
              <BreadcrumbLink to='/cv'>CV</BreadcrumbLink>
              <BreadcrumbLink to='/glossary'>Glossary</BreadcrumbLink>
            </nav>
            <div className='footer-copy'>
              2026 Zachary Upstone.
            </div>
          </div>
        </BackButtonProvider>
      </BreadcrumbProvider>
    </div>
  );
}

export default App;
